import {
  DEFAULT_PROGRESS_BAR_CONFIG,
  type ProgressBarConfig,
} from "../../contracts/src/contracts";

const MIN_INTENSITY = 1;
const MAX_INTENSITY = 3;

export function normalizeProgressBarConfig(
  config?: Partial<ProgressBarConfig>,
): ProgressBarConfig {
  const intensity = Number.isFinite(config?.intensity)
    ? Math.min(MAX_INTENSITY, Math.max(MIN_INTENSITY, config!.intensity!))
    : DEFAULT_PROGRESS_BAR_CONFIG.intensity;
  return {
    mode: config?.mode === "linear" ? "linear" : "accelerated",
    intensity,
  };
}

/** Map real media progress (0..1) to the visual progress shown in the player. */
export function toVisualProgress(
  realRatio: number,
  config?: Partial<ProgressBarConfig>,
): number {
  const ratio = clampRatio(realRatio);
  const normalized = normalizeProgressBarConfig(config);
  if (normalized.mode === "linear" || normalized.intensity === 1) return ratio;
  return clampRatio(1 - Math.pow(1 - ratio, normalized.intensity));
}

/** Inverse mapping used when the viewer clicks or drags the visual progress bar. */
export function fromVisualProgress(
  visualRatio: number,
  config?: Partial<ProgressBarConfig>,
): number {
  const ratio = clampRatio(visualRatio);
  const normalized = normalizeProgressBarConfig(config);
  if (normalized.mode === "linear" || normalized.intensity === 1) return ratio;
  return clampRatio(1 - Math.pow(1 - ratio, 1 / normalized.intensity));
}

function clampRatio(ratio: number): number {
  if (!Number.isFinite(ratio)) return 0;
  return Math.min(1, Math.max(0, ratio));
}
